<template lang="pug">
.content-wrap
  topbar
  .content-top
    .con
      highlight
      rtt
      .cat-tab.nbswi(ref="categories")
        .swiper.glcat-swiper.nbswi-swiper
          .swiper-wrapper
            .swiper-slide
              .cat.aaa
                img(src='/new/img/tab/c-hot.png')
                | hot
            .swiper-slide
              .cat(@click="redirectPath('/slot')")
                img(src='/new/img/tab/c-slot.png')
                | slots
            .swiper-slide
              .cat(@click="redirectPath('/casino')")
                img(src='/new/img/tab/c-casino.png')
                | live
            .swiper-slide
              .cat(@click="redirectPath('/table')")
                img(src='/new/img/tab/c-poker.png')
                | poker
            .swiper-slide
              .cat(@click="redirectPath('/bingo')")
                img(src='/new/img/tab/c-bingo.png')
                | bingo
            .swiper-slide
              .cat(@click="redirectPath('/hash')")
                img(src='/new/img/tab/c-hash.png')
                | hash
            template(v-if="isLoggedIn")
              .swiper-slide
                router-link.cat(to="/launchWbet" target="_blank")
                  img(src='/new/img/tab/c-sport.png')
                  | sports
            template(v-else)
              .swiper-slide
                a.cat(@click="$helpers.openModal('#logModal')")
                  img(src='/new/img/tab/c-sport.png')
                  | sports
            .swiper-slide
              .cat(@click="redirectPath('/fishing')")
                img(src='/new/img/tab/c-fish.png')
                | fishing
        .swiper-button-prev.glcat-swiper-prev
        .swiper-button-next.glcat-swiper-next
      hotGame
      social
    
      //- .load
      //-   | Load more 
      //-   span.loaded 18
      //-   | / 450
      footerInfo(:target="'/'")
</template>
<script>
import { EventBus } from '@/store/event';
import topbar from '@/views/default/_topBar.vue'
import highlight from '@/component/_highlight.vue'
import rtt from '@/component/_realTimeTrans.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
import hotGame from '@/component/slot/_hotgame.vue'
import social from '@/component/_social.vue'
export default {
  components:{
    topbar,
    highlight,
    rtt,
    footerInfo,
    social,
    hotGame
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    // getAnnBefore() {
    //   return this.$store.state.user.annBeforeLog
    // },
  },
  created(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}`);
  },
  mounted(){
    EventBus.$on("scroll", (data) => {
			if(data == true){
				this.$nextTick(() => {
					// then wait for the browser’s layout/paint
					requestAnimationFrame(() => {
						setTimeout(this.scrolltoDiv, 500)
					})
				})
			}
		});
    if ($('.glcat-swiper').length) {
			const gboxSwiper = new Swiper('.glcat-swiper', {
				slidesPerView: 6.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glcat-swiper-next',
					prevEl: '.glcat-swiper-prev'
				},
				watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: {
						slidesPerView: 6.5
					},
					960: {
						slidesPerView: 8
					}
				}
			})
    }
  },
  methods:{
    scrolltoDiv(){
			const el = this.$refs.categories
      if (!el) return
			
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest"  })
		},
    redirectPath(target){
      this.$router.push(target).catch(error =>{}).finally(() => {
        this.$nextTick(() => {
          EventBus.$emit('scroll', true);
        });
      });
    }
  }
}
</script>